// El color de marca del negocio, traducido a las variables del CSS.
//
// La página pública está escrita entera contra cuatro variables —el acento, su
// versión suave para los fondos, su versión de línea para los bordes y la
// tinta que va ENCIMA del acento en los botones— así que pintarla de otro
// color es cambiar esas cuatro y nada más. No hay una sola regla que nombre un
// color a mano.
//
// La lista de colores posibles NO vive acá: la manda el servidor con la
// configuración, y el CHECK de la base es el que garantiza que lo que llegue
// sea uno de ellos. Acá sólo está el verde, para poder reconocerlo.

/** El acento histórico. Hasta la migración 037 era el de todos. */
export const VERDE_DE_SIEMPRE = '#25D366';

const canales = (hex) => {
  const n = hex.replace('#', '');
  return [0, 2, 4].map((i) => parseInt(n.slice(i, i + 2), 16));
};

/**
 * La tinta que va encima del acento: el mismo color, casi negro.
 *
 * Es el color del texto del botón primario y del horario elegido. Tiene que
 * ser oscurísimo —el acento es claro— pero del mismo tono, porque un negro
 * neutro sobre un naranja se ve sucio. Multiplicar por 0.12 da justo eso, y el
 * test mide que ninguno de los siete baje del 4.5:1 que pide la AA.
 */
export const tintaSobre = (hex) =>
  '#' + canales(hex).map((c) => Math.round(c * 0.12).toString(16).padStart(2, '0')).join('');

/**
 * Las variables del CSS para este color, o null si no hay nada que cambiar.
 *
 * Devuelve null para el verde a propósito, y no las mismas variables con los
 * mismos valores: así el negocio que nunca eligió un color no recibe ni un
 * atributo style de más, y su página es byte por byte la de antes. "El que no
 * elige nada no ve ningún cambio" deja de depender de que yo haya copiado bien
 * los rgba del CSS.
 */
export function variablesDeMarca(hex) {
  if (!hex || hex === VERDE_DE_SIEMPRE) return null;

  const [r, g, b] = canales(hex);
  return {
    '--acento': hex,
    '--acento-suave': `rgba(${r}, ${g}, ${b}, 0.12)`,
    '--acento-linea': `rgba(${r}, ${g}, ${b}, 0.28)`,
    '--acento-tinta': tintaSobre(hex)
  };
}
